<template>
<div class="hris-page">
	<div class="hris-page-inner">
		<div class="hris-page-header">
			<span class="hris-page-eyebrow">System Settings</span>
			<h1 class="hris-page-title">Province</h1>
			<p class="hris-page-subtitle">Manage the list of provinces grouped by region.</p>
		</div>

		<q-form ref="vForm" @submit="onSubmit">
			<div class="row q-col-gutter-lg">
				<div class="col-12 col-md-4">
					<div class="hris-form-section">
						<h2 class="hris-form-section-title">Add / Edit Province</h2>
						<div class="hris-form-row">
							<div class="hris-form-field">
								<q-select outlined dense color="green" v-model="region" option-value="id" option-label="region_no" :rules="[formRules.required]" :options="regionOptions" label="Region" emit-value map-options @input="test"></q-select>
							</div>
						</div>
						<div class="hris-form-row">
							<div class="hris-form-field">
								<q-input outlined dense color="green" v-model="province" label="Province" :rules="[formRules.required]" class="caps"></q-input>
							</div>
						</div>
						<div class="hris-form-actions">
							<q-btn unelevated class="hris-q-primary full-width" type="submit" label="Save"></q-btn>
						</div>
					</div>
				</div>
				<div class="col-12 col-md-8">
					<div class="hris-panel">
						<div class="row items-center justify-between q-mb-md">
							<h2 class="hris-panel-title" style="margin-bottom: 0;">Province List</h2>
							<q-input outlined dense color="green" v-model="searchKey" placeholder="Search" style="max-width: 220px;" class="caps">
								<template v-slot:append>
									<i class="fas fa-search"></i>
								</template>
							</q-input>
						</div>
						<q-table
							flat
							:data="searchResult"
							:columns="columns"
							row-key="id"
							:pagination.sync="pagination"
						>
							<template v-slot:body="props">
								<q-tr slot="body" :props="props" @click="selectedRow(props)" style="cursor: pointer;">
									<q-td key="id" :props="props">{{ props.row.counter }}</q-td>
									<q-td key="region" :props="props">{{ props.row.region }}</q-td>
									<q-td key="province" :props="props">{{ props.row.province }}</q-td>
									<q-td key="action" :props="props">
										<q-btn flat round dense class="hris-q-ghost" @click="removeRow(props)">
											<i class="fas fa-trash"></i>
											<q-tooltip anchor="top middle" self="bottom middle" :offset="[10, 10]">
												<strong>Remove</strong>
											</q-tooltip>
										</q-btn>
									</q-td>
								</q-tr>
							</template>
							<template v-slot:no-data="">
								<div class="hris-empty full-width">
									No results found.
								</div>
							</template>
						</q-table>
					</div>
				</div>
			</div>
		</q-form>

		<q-dialog v-model="spinner" persistent>
			<div class="hris-loading" style="background: #fff; border-radius: 14px; padding: 32px 44px;">
				<q-spinner color="green" size="40px"></q-spinner>
			</div>
		</q-dialog>

		<q-dialog v-model="deleted" persistent>
			<div class="hris-modal">
				<div class="hris-modal-header">
					<h2 class="hris-modal-title">Confirm Deletion</h2>
				</div>
				<div class="hris-modal-body">
					This record will be permanently deleted.
				</div>
				<div class="hris-modal-footer">
					<q-btn flat label="Cancel" class="hris-q-ghost" v-close-popup></q-btn>
					<q-btn unelevated label="Delete" class="hris-q-primary" v-close-popup @click="deletionConfirmation"></q-btn>
				</div>
			</div>
		</q-dialog>
	</div>
</div>
</template>

<script>
import axios from 'axios';
import mixins from '../../mixins';


export default {

	data () {
		return {
			tempID:0,
			spinner:false,
			deleted:false,
			region:null,
			regionOptions:[],
			province:null,
			searchKey:null,
			data:[],
			columns: [
			{ name: 'id', align: 'center', label: 'ID', field: 'id', sortable: true },
			{ name: 'region', align: 'center', label: 'Region', field: 'region', sortable: true },
			{ name: 'province', align: 'center', label: 'Location', field: 'province', sortable: true },
			{ name: 'action', align: 'center', label: 'Action', field: '', sortable: true },
			],
			pagination: {
				rowsPerPage: 20
			},
		}
	},

	created(){
		this.displayRegions()
		this.displayData()

	},

	computed: {
		searchResult() {
			if (this.searchKey !== null) {
				return this.data.filter(prov => {
					
					var res1 = prov.region.replace("(", "");
					var res2 = res1.replace(")", "");
					return res2.match(this.searchKey.toUpperCase()) || prov.province.match(this.searchKey.toUpperCase())
				});
			} else {
				return this.data
			}
		}
	},

	methods: {

		onSubmit : function(){
			this.spinner = true;
			let formData = new FormData();
			formData.append("regionID", this.region);
			formData.append("province", this.province);
			formData.append("tempID", this.tempID);

			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post('/admin/province',formData)
			.then((res) => {
				this.displayData()
				this.region = ''
				this.province = ''
				this.tempID = 0
				this.spinner = false;
				this.$refs.vForm.reset()
			});
		},

		displayData: function() {
			axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}})
			.get(`/admin/provinces`)
			.then((res) => {
				this.data = res.data.data;
				setTimeout(() => {
					this.spinner = false
				},500)
			})

		},


		displayRegions: function() {
			axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}})
			.get(`/admin/regions`)
			.then((res) => {
				this.regionOptions = res.data.data;
				setTimeout(() => {
					this.spinner = false
				},500)
			})

		},

		selectedRow:function(obj){
			this.province = obj.row.province
			this.region = obj.row.region_no
			this.tempID = obj.row.id
		},

		removeRow:function(obj){

			this.deleted = true
			this.tempID = obj.row.id
		},

		test:function(){

		},

		deletionConfirmation:function(){
			this.spinner = true;
			let formData = new FormData();
			formData.append("tempID", this.tempID);
			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post('/admin/province/delete',formData)
			.then((res) => {
				this.tempID = 0
				this.displayData()
			});
		}

	}
}
</script>
<style>
.caps {
	text-transform: uppercase
}
</style>
